import React from 'react'

import { MenuContext } from './MenuRoot'

interface MenuTriggerProps {
    children: React.ReactNode
    pointer?: boolean
}

export default function MenuTrigger({ children, pointer }: MenuTriggerProps) {
    const onClickChild = (children as React.ReactElement).props.onClick

    const only = React.Children.map(children, (_, index) => index)?.length
    if (only !== 1) throw new Error('MenuTrigger must have only one child')

    if (!React.isValidElement(children)) {
        throw new Error('MenuTrigger must have a valid child')
    }

    return (
        <MenuContext.Consumer>
            {({ handleClick, id, open }) =>
                React.cloneElement(children as React.ReactElement, {
                    id: id + '-trigger',
                    'aria-controls': id + '-menu',
                    'aria-haspopup': 'true',
                    'aria-expanded': open ? 'true' : undefined,
                    style: pointer ? { cursor: 'pointer' } : undefined,
                    onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                        onClickChild?.(event)
                        handleClick(event)
                    },
                })
            }
        </MenuContext.Consumer>
    )
}
